import { Box, Collapse, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import React, { useState } from 'react'
import QrReader from 'react-qr-reader'
import './QrPairingEditor.css'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { logError } from 'src/Libs/flow/utils'

interface QrPairingEditorProps {
  startQrScanner: boolean
  setStartQrScanner: React.Dispatch<React.SetStateAction<boolean>>
  setPairingId: React.Dispatch<React.SetStateAction<string>>
  onScan?: (
    data: string | null,
    setPairingId: (value: string) => void,
    setStartQrScanner: (value: boolean) => void,
    setScannerError: (value: string) => void
  ) => void
}
/** QR-Code pairing reader */
export const QrPairingEditor: React.FC<QrPairingEditorProps> = ({ startQrScanner, setStartQrScanner, setPairingId, onScan }) => {
  const { t } = useCustomTranslation()

  const theme = useTheme()
  const downMd = useMediaQuery(theme.breakpoints.down('md'))

  const [scannerError, setScannerError] = useState<string | undefined>()
  const [validationErrorMessage, setValidationErrorMessage] = useState<string | undefined>()

  const handleScan = (data: string | null): void => {
    if (onScan) {
      onScan(data, setPairingId, setStartQrScanner, setValidationErrorMessage)
      return
    }

    if (data) {
      if (data.startsWith('https://hgr.io/u/')) {
        const splitted = data.split('/')
        setPairingId(splitted[splitted.length - 1])
      }
      setStartQrScanner(false)
      setScannerError('')
    }
  }

  return (
    <Box>
      <Collapse appear={true} in={startQrScanner} mountOnEnter={true} unmountOnExit={true}>
        <QrReader
          delay={300}
          onError={(error: Error) => {
            logError(error)
            setScannerError(error.name)
            setStartQrScanner(false)
          }}
          onScan={handleScan}
          style={{ width: '100%' }}
          className={'qr'}
        />
      </Collapse>
      {scannerError && (
        <Typography color="error" align="right">
          {downMd && scannerError === 'NotAllowedError'
            ? t('installation.productEditor.mobileCameraAccessDeniedError')
            : scannerError === 'NotAllowedError'
            ? t('installation.productEditor.notAllowedError')
            : t('installation.productEditor.unknownError')}
        </Typography>
      )}
      {validationErrorMessage && (
        <Typography color="error" align="right">
          {validationErrorMessage}
        </Typography>
      )}
    </Box>
  )
}
